/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Term/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Term({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Details/Office/City/Term",
  isInvalid,
  onChange
  
}) {
let editProfessionalOtherExternalOfficePostalAddressCityIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_professional',
path: 'other.external_office.postal_address.city',
validate: fromValidate.city,
required: true,
})
let citySearchTermValueData = fromData.useDataValue({ viewPath,
context: 'city_search',
path: 'term',
})
let citySearchTermChangeData = fromData.useDataChange({ viewPath,
context: 'city_search',
path: 'term',
})
  return (<React.Fragment
>
<div
  data-testid="Term.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 data="edit_professional.other.external_office.postal_address.city"
 validate="/Data/validate.js city"
 required={true}
 invalid={!editProfessionalOtherExternalOfficePostalAddressCityIsValidData}
 data="city_search.term"
 value={citySearchTermValueData}
 onChange={citySearchTermChangeData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
</div>
{children}
</React.Fragment>)
}